





























































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import UserAPI from '@/services/UserAPI';

import User from '@/types/User';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';

import utilMixin from '@/mixin/Util';
import Util from '@/util/Util';
import { UserRole } from '@/types/UserRole';
import ContactInfo from '@/types/ContactInfo';

export default Vue.extend({
    name: 'SignUp',

    components: {
        Field,
        TInput
    },

	created() {
        Util.updateHeaders((this as any).$text('signUp'), (this as any).$text('signUpMoominhouse'), process.env.VUE_APP_DEFAULT_IMAGE);
        this.user.firstName = '';
        this.user.lastName = '';
        this.user.contactInfo = new ContactInfo();
        this.user.password = '';
        this.user.role = UserRole.Client;
    },

    mixins: [utilMixin],

    computed: {
        ...mapState(['characters', 'language']),

        ...mapGetters(['characterById']),

        isValidEmail(): boolean {
            return Util.validateEmail(this.user.contactInfo.email);
        }
    },

    data() {
        return {
            user: new User(),
            passwordCheck: '',
            error: {
                name: '',
                email: '',
                password: '',
                passwordCheck: '',
                character: '',
                save: ''
                },
            status: '',
            isLoading: false
        };
    },

    methods: {
        signUp(language: string): void {
            if (Util.isEmpty(this.user.firstName) || Util.isEmpty(this.user.lastName)) {
                this.error.name = (this as any).$text('supplyFirstAndLastname');
            } else {
                this.error.name = '';
            }

            if (!this.user.contactInfo.email || !this.isValidEmail) {
                this.error.email = (this as any).$text('supplyCorrectEmail');
            } else {
                this.error.email = '';
            }

            if (Util.isEmpty(this.user.password)) {
                this.error.password = (this as any).$text('missingPassword');
            } else {
                this.error.password = '';
            }

            if (this.user.password !== this.passwordCheck) {
                this.error.passwordCheck = (this as any).$text('passwordCheckNoMatch');
            } else {
                this.error.passwordCheck = '';
            }

            if (Util.isEmpty(this.user.characterId)) {
                this.error.character = (this as any).$text('chooseCharacter');
            } else {
                this.error.character = '';
            }

            if (this.error.name === '' &&
                this.error.email === '' &&
                this.error.password === '' &&
                this.error.passwordCheck === '' &&
                this.error.character === '') {

                const handleResponse = (response: AxiosResponse) => {
                        this.status = response.data;
                        this.$router.push('/validate');
                    };

                const handleError = (error: AxiosError) => {
                        if (error.response) {
                            this.error.save = error.response.data.message;
                        }
                    };

                this.isLoading = true;
                UserAPI
                    .signUp(this.user, language)
                    .then(handleResponse)
                    .catch(handleError)
                    .finally(() => this.isLoading = false);
            }
        }
    }
});
